import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { UsePriceDisplayParams } from "@b2bportal/core-ui";
import { Trans } from "@hopper-b2b/i18n";
import { usePriceDisplay } from "@tenant/ui";
import clsx from "clsx";
import styles from "./PackageCarPriceDisplay.module.scss";

export type PackageCarPriceDisplayProps = UsePriceDisplayParams &
  PlatformComponentProps;

export const PackageCarPriceDisplay: React.FC<PackageCarPriceDisplayProps> = (
  props
) => {
  const [block, cn] = useModuleBEM(styles, "PackageCarPriceDisplay");

  const { priceText, rewardsText } = usePriceDisplay(props);

  if (rewardsText) {
    return (
      <span className={clsx(block, props.className)}>
        <Trans
          i18nKey="core-packages.cars.priceDisplay.rewardsOrPrice"
          components={{
            rewards: <span className={cn("rewards")} />,
            price: <span className={cn("price")} />,
          }}
          values={{
            rewards: rewardsText,
            price: priceText,
          }}
        />
      </span>
    );
  }

  return <span className={clsx(block, props.className)}>{priceText}</span>;
};
